import React from 'react'
import { useSelector } from 'react-redux'

import AdDv360CreateForm from './AdDv360CreateForm'
import FormDrawerWrapper from '../../../../features/components/FormDrawerWrapper'
import { useExceptedAdsModal } from '../../ExceptedAdsModal/useExceptedAdsModal'

import { lineItemSelector } from '../../../../modules/selectors/lineItems'

import { LINE_ITEM_TYPE } from '../../UploadDV360AdCreative/UploadDV360AdCreativeForm/LineItemForm/fields'
import { AD_DV360_CREATE } from '../../../../constants/forms'

const AdDv360Create = () => {
  const { handleAdsExceptions, ExceptedAdsModal } = useExceptedAdsModal()

  const { [LINE_ITEM_TYPE]: lineItemType } = useSelector(lineItemSelector)

  return (
    <>
      <FormDrawerWrapper formName={AD_DV360_CREATE} openButtonText="Create Ad">
        <AdDv360CreateForm handleAdsExceptions={handleAdsExceptions} lineItemType={lineItemType} />
      </FormDrawerWrapper>
      {ExceptedAdsModal}
    </>
  )
}

export default AdDv360Create
